"use client";

import { useState } from "react";
import { ArrowRight, Minus, Plus } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const faqs = [{
  question: "How do I start trading on KTEX?",
  answer: "To begin trading, simply register as a buyer or supplier through our platform. Once your account is verified by our compliance team, you can start browsing listings or posting your procurement requirements immediately."
}, {
  question: "What measures ensure the quality of products?",
  answer: "We implement a multi-layered verification process. Suppliers must pass rigorous quality audits, and we offer third-party inspection services for high-value orders to ensure that every shipment meets international standards and your specific requirements."
}, {
  question: "How are international payments handled?",
  answer: "KTEX provides secure, integrated payment solutions that support multiple currencies. Our platform uses escrow-like mechanisms and advanced encryption to ensure that funds are only released when trade milestones and documentation requirements are met."
}, {
  question: "What logistics support do you provide?",
  answer: "We partner with leading global logistics providers to offer end-to-end shipping solutions. From automated documentation and customs clearance support to real-time tracking, we simplify the complexities of international freight for our members."
}];
export default function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const toggle = (i: number) => {
    setOpenIndex(openIndex === i ? null : i);
  };
  return <section data-section-id="4005" id="faqaccordion" className="bg-white text-slate-900 py-32 md:py-[200px] px-6 md:px-12">
      <div ref={ref} className={`max-w-[1400px] mx-auto transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
          {}
          <div className="lg:col-span-4 lg:col-start-1">
            <div className="lg:sticky lg:top-32">
              <p className="font-sans text-xs tracking-[0.2em] uppercase text-slate-500 mb-8">
                Frequently Asked Questions
              </p>
              <h2 className="font-default text-4xl md:text-5xl lg:text-[56px] leading-[1.05] font-bold text-slate-900 mb-10">
                Trading insights,
                <br />
                simplified.
              </h2>
              <p className="font-sans text-lg text-slate-600 mb-6 leading-relaxed">
                Need further assistance? Our support team is ready to help.
              </p>
              <Link to="/ContactPage" className="inline-flex items-center gap-2 font-sans text-xs tracking-[0.2em] uppercase text-blue-900 hover:text-blue-700 transition-colors duration-300 group">
                <span>Contact Support</span>
                <ArrowRight className="w-3.5 h-3.5 transition-transform duration-300 group-hover:translate-x-1" />
              </Link>
            </div>
          </div>

          {}
          <div className="lg:col-span-6 lg:col-start-7">
            <div className="border-t border-slate-200">
              {faqs.map((faq, i) => {
              const isOpen = openIndex === i;
              return <div key={i} data-index={i} className="border-b border-slate-200">
                    <button onClick={() => toggle(i)} className="w-full flex items-center justify-between text-left py-6 md:py-7 min-h-[80px] gap-6 group" aria-expanded={isOpen}>
                      <span className={`font-default text-lg md:text-xl leading-snug transition-colors duration-300 ${isOpen ? "text-slate-900 font-semibold" : "text-slate-600 group-hover:text-slate-900"}`}>
                        {faq.question}
                      </span>
                      <span className="flex-shrink-0">
                        {isOpen ? <Minus className="w-5 h-5 text-blue-900 transition-all duration-300" strokeWidth={2} /> : <Plus className="w-5 h-5 text-slate-400 group-hover:text-blue-900 transition-all duration-300" strokeWidth={2} />}
                      </span>
                    </button>
                    <div className="grid transition-all duration-[400ms] ease-in-out" style={{
                  gridTemplateRows: isOpen ? "1fr" : "0fr"
                }}>
                      <div className="overflow-hidden">
                        <div className="pb-8 pl-6 border-l-2 border-blue-900 ml-0 md:ml-2">
                          <p className="text-base text-slate-600 leading-[1.7] font-sans">
                            {faq.answer}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>;
            })}
            </div>
          </div>
        </div>
      </div>
    </section>;
}